import React from 'react'
import { Switch, Router, Redirect, Route } from 'react-router'
import PropTypes from 'prop-types'
import PageRoute from './PageRoute'

const NotFoundRedirect = () => <Redirect to="/" />

const Routing = ({ history }) => (
  <Router history={history}>
    <Switch>
      <PageRoute
        path="/"
        exact
      />
      <Route component={NotFoundRedirect} />
    </Switch>
  </Router>
)

Routing.propTypes = {
  history: PropTypes.object
}


export default Routing
